import { TTechClaimIntakeClient } from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "src/auth/helpers";
import { setupClaimIntakeClient } from "./setupClaimIntakeClient";

export type AuthenticatedClientResult =
  | { client: TTechClaimIntakeClient; token: string }
  | { client: null; token: null };

/**
 * Authenticates and returns a configured service client.
 *
 * Usage:
 * ```ts
 * const { client } = await getAuthenticatedClient();
 * if (!client) return null; // or return an unauthorized response
 * ```
 *
 * This centralizes the token-fetch + client-setup flow that every API
 * service file repeats.
 */
export async function getAuthenticatedClient(): Promise<AuthenticatedClientResult> {
  const token = await getAuthenticationToken();
  if (!token) {
    return { client: null, token: null };
  }
  return { client: setupClaimIntakeClient(token), token };
}
